import { render, staticRenderFns } from "./TouchpointStatisticsDetails.vue?vue&type=template&id=359e4419&scoped=true&"
import script from "./TouchpointStatisticsDetails.vue?vue&type=script&lang=js&"
export * from "./TouchpointStatisticsDetails.vue?vue&type=script&lang=js&"
import style0 from "./TouchpointStatisticsDetails.vue?vue&type=style&index=0&id=359e4419&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359e4419",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('359e4419')) {
      api.createRecord('359e4419', component.options)
    } else {
      api.reload('359e4419', component.options)
    }
    module.hot.accept("./TouchpointStatisticsDetails.vue?vue&type=template&id=359e4419&scoped=true&", function () {
      api.rerender('359e4419', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/TouchpointOverview/Statistics/TouchpointStatisticsDetails.vue"
export default component.exports